import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Config } from 'src/app/shared/models/config.model';
import { ConfigClienteService } from 'src/app/shared/services/config-cliente/config-cliente.service';
import { ConfigService } from 'src/app/shared/services/config.service';
import { AuthService } from '../../../../services/auth/auth.service';
import { SocketConnectionService } from 'src/app/shared/services/socketConnection/socket-connection.service'; 


@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit {

  // MC CATFER-92 Recibo el nombre del cliente para mostrarlo en el menú
  @Input() nombreCliente: string;

  rol: number;

  invitado = false;
  admin = false;
  public exitPage: string;

  get usuario(){
    return this.authService.usuario;
  }

  public openNotification: boolean = false;

  constructor(private authService: AuthService, private configService:ConfigService, private router: Router,
    private configClienteService: ConfigClienteService, private socketConn: SocketConnectionService) { }

  ngOnInit() {
    this.configClienteService.getConfigCliente(this.authService.usuario.id_cliente);
    this.invitado = this.authService.usuario.invitado;

    this.admin = this.authService.usuario.admin;
    
    this.exitPage = this.configService.config.cliente.exit_page;

    this.rol = this.authService.usuario.id_rol_usr_web;
  }

  toggleNotificationMobile() {
    this.openNotification = !this.openNotification;
  }

  logout(){
    this.socketConn.desconectarConnection();
    localStorage.removeItem("data");
  }

  logoutAdmin(){
    if(this.admin){
      this.authService.logoutAdmin(this.authService.usuario.user_id).subscribe(resp => {
        localStorage.removeItem("data");
      });
    }
  }

}
